import src from "IMAGE";
export default { src, width: 1246, height: 88, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJklEQVR42mPgFVUs4hGWy+AWlk3hYGtx52T4HwfE8UCcysHwIxIAbb4IZkYfm78AAAAASUVORK5CYII="};
